import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttrLODIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    width,
    height,
    color = 'currentColor',
    onClick,
  }) => {
    const clipId = React.useId();

    return (
      <BaseIcon
        className={className}
        size={size}
        width={width}
        height={height}
        color={color}
        onClick={onClick}
        viewBox="0 0 24 24"
      >
        <g clipPath={`url(#${clipId})`}>
          <path
            d="M23 16H17C16.447 16 16 16.447 16 17V23C16 23.553 16.447 24 17 24H23C23.553 24 24 23.553 24 23V17C24 16.447 23.553 16 23 16ZM22 22H18V18H22V22Z"
            fill={color}
          />
          <path
            d="M4.5 9C6.981 9 9 6.981 9 4.5C9 2.019 6.981 0 4.5 0C2.019 0 0 2.019 0 4.5C0 6.981 2.019 9 4.5 9ZM4.5 2C5.878 2 7 3.122 7 4.5C7 5.878 5.878 7 4.5 7C3.122 7 2 5.878 2 4.5C2 3.122 3.122 2 4.5 2Z"
            fill={color}
          />
          <path
            d="M16.279 10.107C16.279 9.74999 16.089 9.41899 15.779 9.24099L12.5 7.34699C12.19 7.16799 11.809 7.16799 11.5 7.34699L8.22101 9.24099C7.91101 9.41999 7.72101 9.74899 7.72101 10.107V13.893C7.72101 14.25 7.91101 14.581 8.22101 14.759L11.5 16.654C11.809 16.832 12.191 16.832 12.5 16.654L15.779 14.759C16.089 14.58 16.279 14.25 16.279 13.893V10.107ZM14.279 13.315L12 14.631L9.72101 13.315V10.684L12 9.36799L14.279 10.684V13.315Z"
            fill={color}
          />
          <path
            d="M12 3H20V7H19C18.225 6.975 17.719 7.924 18.168 8.555L20.168 11.555C20.535 12.142 21.465 12.142 21.832 11.555L23.832 8.555C24.281 7.925 23.775 6.976 23 7H22V2C22 1.448 21.553 1 21 1H12C11.448 1 11 1.448 11 2C11 2.552 11.448 3 12 3Z"
            fill={color}
          />
          <path
            d="M12 21H4.00003V17H5.00003C5.77403 17.025 6.28203 16.075 5.83203 15.445L3.83203 12.445C3.46103 11.888 2.53903 11.888 2.16803 12.445L0.168028 15.445C-0.281972 16.075 0.226028 17.024 1.00003 17H2.00003V22C2.00003 22.553 2.44803 23 3.00003 23H12C12.552 23 13 22.553 13 22C13 21.447 12.552 21 12 21Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id={clipId}>
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </BaseIcon>
    );
  },
);

AttrLODIcon.displayName = 'AttrLODIcon';
